<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <DropFile @loadSuccessModal="loadSuccessModal" @loadErrorModal="loadErrorModal"/>
  </Modal>
</template>

<script>
import Modal from '../../../Shared/Modal.vue';
import DropFile from './DropFile.vue';

export default {
  name: 'UploadWhitelist',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
  ],
  data() {
    return {
      classes: this.class,
      errorCode: '',
      errorMessage: ''
    };
  },
  components: {
    Modal,
    DropFile,
  },
  methods: {
    loadSuccessModal(){
      this.$emit('loadSuccessModal');
    },
    loadErrorModal(error){
      this.$emit('loadErrorModal', error);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
